import { makeStyles } from '@material-ui/styles';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { CaretDownOutlined } from '@ant-design/icons';
import useBoolean from 'common/hooks/useBoolean';

const useButtonStyles = makeStyles(
  theme => ({
    default: {
      ...theme.typography.body2,
      padding: '5px 8px',
      border: `1px solid ${theme.colors.gray5}`,
      backgroundColor: theme.colors.gray1,
      borderRadius: theme.borderRadius.min,
      ...theme.flex.crossCenter,
      cursor: 'pointer',
      fontWeight: 600,
      color: theme.colors.captionColor,

      '& > *:not(:first-child)': {
        marginLeft: 8,
      },

      '&:hover': {
        borderColor: theme.colors.mainGreen6,
      },
    },
    selected: {
      color: theme.colors.mainGreen6,
      boxShadow: theme.shadow.btn,

      '& svg': {
        fill: theme.colors.mainGreen6,
      },
    },
    icon: {
      fontSize: '10px',
    },
    noBorder: {
      color: theme.colors.captionColor,
      boxShadow: 'none',
      border: 0,
      background: 'none',

      '&:hover': {
        backgroundColor: theme.colors.gray3,
      },
      '& svg': {
        fill: theme.colors.captionColor,
      },
    },
    filterSvg: {
      fontSize: '12px',
      color: '#9E9E9E',
      marginLeft: '8px',
    },
    svgRotate: {
      transform: 'rotateX(180deg)',
      transformOrigin: 'center',
    },
    highLight: { color: theme.colors.mainGreen6 },
    hightLightSvg: { '& svg': { fill: theme.colors.mainGreen6 } },
  }),
  { name: 'SelectButton' },
);

const SelectButton = ({
  onClick,
  selectedOption,
  noBtnBorder,
  btnText,
  filterIcon,
  showSelectedOption,
  hasOutlinedIcon = true,
  open,
  btnHighLight,
}) => {
  const classes = useButtonStyles();
  const [isOpenDropdown, { toggle: toggleIcon }] = useBoolean(false);

  const handleClickBtn = () => {
    onClick();
    toggleIcon();
  };

  return (
    <button
      className={classNames(classes.default, {
        [classes.selected]: !!selectedOption,
        [classes.noBorder]: noBtnBorder,
      })}
      onClick={handleClickBtn}
    >
      <If condition={!!filterIcon}>{filterIcon}</If>

      <Choose>
        <When condition={showSelectedOption && selectedOption?.label}>
          <span className={`${btnHighLight ? classes.highLight : ''}`}>
            {selectedOption?.label}
          </span>
        </When>
        <Otherwise>
          <span>{btnText}</span>
        </Otherwise>
      </Choose>

      <If condition={hasOutlinedIcon}>
        {isOpenDropdown ? (
          <UpOutlined className={classes.icon} />
        ) : (
          <DownOutlined className={classes.icon} />
        )}
      </If>
      <If condition={!filterIcon}>
        <CaretDownOutlined
          className={`${classes.filterSvg} ${open ? classes.svgRotate : ''}
          ${btnHighLight && showSelectedOption ? classes.hightLightSvg : ''}
        `}
        />
      </If>
    </button>
  );
};

SelectButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  selectedOption: PropTypes.object,
  noBtnBorder: PropTypes.bool,
  showSelectedOption: PropTypes.bool,
  btnText: PropTypes.string,
  hasOutlinedIcon: PropTypes.bool,
  filterIcon: PropTypes.object,
  open: PropTypes.bool,
  btnHighLight: PropTypes.bool,
};

export default SelectButton;
